import * as Constants from "../common/Constants";

const initialState = {
    attachments: [],
    isLoading: false,
    isPosting: false,
    isPosted: false,
    error: null,
    newEntry: null
};

export default function attachmentReducer(state = initialState, action) {

    var newState;
    switch (action.type) {

        case Constants.REQUEST_ADD_ATTACHMENT:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            if (action.newEntry) {
                newState.attachments = [...newState.attachments, action.newEntry];
            }
            return newState;

        case Constants.FAILED_ADD_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_ATTACHMENT:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            return newState;

        case Constants.SUCCESS_GET_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.attachments = action.attachments;
            return newState;

        case Constants.FAILED_GET_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_UPDATE_ATTACHMENT:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_UPDATE_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_UPDATE_ATTACHMENT:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_ATTACHMENT:
            newState = { ...state };
            newState.attachments = [];
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/AttachmentReducer.js